import { inkFontTokens } from '@ds/tokens';
import styled from '@emotion/styled';

const FontDetailS = styled.div`
    ${inkFontTokens.fontDetailS}
`;

export default FontDetailS;
